/**
 * livePnl.js
 * Live P&L using real-time LTP from WebSocket.
 *
 * Signal controls direction:
 *   Cash / Advisory → "BUY"  | "SELL"
 *   Futures         → "LONG" | "SHORT"
 *
 * BUY  / LONG  : profit = (ltp - entry) × qty
 * SELL / SHORT : profit = (entry - ltp) × qty
 *
 * For futures pass lotSize — it multiplies into qty automatically.
 */

const PROFIT_SIGNALS = ["BUY", "LONG"];

/**
 * @param {object} p
 * @param {number|string} p.entryPrice
 * @param {number|string} p.ltp          - live price from WS
 * @param {number|string} p.quantity     - shares (cash) or lots (future)
 * @param {number|string} [p.lotSize]    - units per lot; omit for cash/advisory
 * @param {string}        p.signal       - "BUY" | "SELL" | "LONG" | "SHORT"
 *
 * @returns {{ pnl: number, pnlPercent: number, isProfit: boolean } | null}
 */
export const calcLivePnl = ({ entryPrice, ltp, quantity = 1, lotSize = 1, signal = "BUY" }) => {
  const entry = parseFloat(entryPrice);
  const price = parseFloat(ltp);
  const qty   = parseFloat(quantity) || 1;
  const lot   = parseFloat(lotSize)  || 1;

  if (!entry || !price || isNaN(entry) || isNaN(price)) return null;

  const direction = PROFIT_SIGNALS.includes(signal?.toUpperCase()) ? 1 : -1;

  const pnl        = direction * (price - entry) * qty * lot;
  const pnlPercent = direction * ((price - entry) / entry) * 100;

  return {
    pnl:        parseFloat(pnl.toFixed(2)),
    pnlPercent: parseFloat(pnlPercent.toFixed(2)),
    isProfit:   pnl >= 0,
  };
};
